import t from '~/javascripts/utils/translation';
import { observer } from 'mobx-react';

const UserCampaignDonateByCheck = observer(
  ({ campaignName, campaignCheckCode, handleClose }) => (
    <div className='donate-by-check modal' id='donate-by-check'>
      <div className='modal-inner mb-2 pb-3'>
        <div className='modal-close' onClick={handleClose} />
        <div className='modal-title'>
          <em className='h80'>You&rsquo;re giving to</em>
          <h2 className='h40'>{campaignName}</h2>
        </div>
        <div className='row'>
          <div className='large-6 columns text-center'>
            <div>
              <p className='info-body whitespace-pre-wrap text-sm'>
                Make your check payable to <strong>charity: water</strong>.
                Write the code below in the memo so we can track it to the
                correct campaign.
              </p>
              <div className='panel font-medium'>
                <div className='address-line'>&nbsp;</div>
                <div className='address-line text-sm uppercase'>
                  {campaignCheckCode}
                </div>
                <div className='address-line'>&nbsp;</div>
              </div>
            </div>
          </div>
          <div className='large-6 columns text-center'>
            <div>
              <p className='info-body whitespace-pre-wrap text-sm'>
                Then, drop your check in the mail! You&rsquo;ll receive an
                official tax receipt about 3 - 4 weeks after your check is
                processed.
              </p>
              <div className='panel font-medium flex flex-col items-center justify-center'>
                <div className='address-line text-sm'>{t('site.label')}</div>
                <div className='address-line text-sm'>
                  {t('address.multi_line.street')}
                </div>
                <div className='address-line text-sm'>
                  {t('address.multi_line.city_state_zip')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
);

export default UserCampaignDonateByCheck;
